import React from 'react';
import './ColumnTeam.css';
import Team from './Team.mjs';
import ShortList from './ShortList.mjs';
import LongList  from './LongList.mjs';
import AppAdmin from './AppAdmin.mjs';
import { useCTAL } from './CTAL_Hooks.js';

export default function ColumnTeam() 
{
    const {action_item_list_display} = useCTAL();

    if (!action_item_list_display) return;

    switch(action_item_list_display)
    {
        case "team-display":
        case "team-assigned-display":
            return ( <> <Team /> </> );
        case "user-short-list-display":
            return ( <> <ShortList /> </> );
        case "user-long-list-display":
            return ( <> <LongList /> </> );
        case "user-app-admin-display":
            return ( <> <AppAdmin /> </> );
        default:
            return;
    }
}